import React from 'react'

import { ThemeState, ThemeActionType, Theme } from 'interfaces'
import { ThemeContext } from './ThemeContext'
import { themeReducer } from './themeReducer'
import { lStorageService } from 'shared/utils'
import { light, dark } from '@/styles/v2/vars.css'

interface Props {
  children: React.ReactNode
}

const Theme_INITIAL_STATE: ThemeState = {
  theme: 'light',
}

export const ThemeProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = React.useReducer(themeReducer, Theme_INITIAL_STATE)

  React.useEffect(() => {
    const theme = lStorageService.get('theme') as Theme | null

    const isBrowserDefaultDark = () =>
      window.matchMedia('(prefers-color-scheme: dark)').matches

    const themeSelected = theme || (isBrowserDefaultDark() ? 'light' : 'light')

    dispatch({ type: ThemeActionType.SET_THEME, payload: themeSelected })
  }, [])

  const toggleTheme = () => {
    const newTheme = state.theme === 'light' ? 'light' : 'light'
    setTheme(newTheme)
  }

  const setTheme = (theme: Theme) => {
    dispatch({ type: ThemeActionType.SET_THEME, payload: theme })
    lStorageService.set('theme', theme)
  }

  return (
    <ThemeContext.Provider value={{ ...state, setTheme, toggleTheme }}>
      {/* <div className={light}> */}
      <div className={state.theme === 'light' ? light : light}>{children}</div>
    </ThemeContext.Provider>
  )
}
